<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-3 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h2 class="display-2  text-white">3Z Controller
                                    <span>All Yard Switch Machine/IO Control Module</span>
                                </h2>
                                <p class="lead  text-white">3Z-SC-100 control module is a great choice for Switch/Derail control solutions. 3Z-SC-100 control module is a fast boot single board computer which boots a Linux 3.14 kernel Debian Wheezy distribution. 3Z-SC-100 is designed for controlling switch/derail machine applications. 3Z-SC-100 also has flexible IO control feature for all kinds of product.</p>
                            </div>
                            <div class="col-lg-6">
                                <img src="img/3z/controller.png" class="img-fluid shadow">
                                <!-- <img src="img/3z/controller.png" class="img-fluid floating"> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-6">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-gears" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Features</h6>
                                    <ul class="list">
                                        <li>Reliable Data Storage with 2 GB SLC eMMC Flash</li>
                                        <li>16 inputs and outputs</li>
                                        <li>Rugged, Industrial Environment Ready with Fanless -40°C to +85°C Range</li>
                                        <li>Web based configuration</li>
                                    </ul>
                                    <div>
                                        <badge type="primary" rounded>Stable</badge>
                                        <badge type="primary" rounded>Durable</badge>
                                        <badge type="primary" rounded>Configurable</badge>
                                    </div>
                                    <!-- <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Learn more
                                    </base-button> -->
                                </card>
                            </div>
                            <div class="col-lg-6">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-microchip" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Communication Protocols</h6>
                                    <ul class="list">
                                        <li>Genesis (serial & UDP versions)</li>
                                        <li>GE 3000LP Green-board (serial & UDP versions)</li>
                                        <li>Modbus (TCP versions)</li>
                                    </ul>
                                    <div>
                                        <badge type="warning" rounded>hardware</badge>
                                        <badge type="warning" rounded>optomatized</badge>
                                        <badge type="warning" rounded>agile</badge>
                                    </div>
                                    <!-- <base-button tag="a" href="#" type="success" class="mt-4">
                                        Learn more
                                    </base-button> -->
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg ">
            <div class="container">
                <div class="row row-grid justify-content-left">
                    <div class="col-lg-12 text-left">
                        <h2 class="display-2">Here are some successful projects 3Z operated with customers:
                        </h2>
                        <hr>
                    </div>
                    <div class="col-lg-4">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon gradient="darkred" color="white" shadow
                                    rounded>UP</icon>
                            <h5 class="title text-red mt-2">Union Pacific</h5>
                            <p>UP purchase 3Z-SC-100 control module to serve different kinds of switch machine in the yard.</p>
                        </card>
                    </div>
                    <div class="col-lg-4">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon gradient="darkred" color="white" shadow
                                    rounded>BN</icon>
                            <h5 class="title text-red mt-2">BNSF</h5>
                            <p>BNSF Argentine NX system I/O control project.<br><br></p>
                        </card>
                    </div>
                    <div class="col-lg-4">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon name="ni ni-building" gradient="darkred" color="white" shadow
                                    rounded></icon>
                            <h5 class="title text-red mt-2">NorTrak</h5>
                            <p>Voestalpine NorTrak Automater switch machine HP/HT, HSM.<br><br></p>
                        </card>
                    </div>
                    <div class="col-lg-4">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon gradient="darkred" color="white" shadow
                                    rounded>GE</icon>
                            <h5 class="title text-red mt-2">GE</h5>
                            <p>Hydra-switch 3000LP machine.<br><br></p>
                        </card>
                    </div>
                    <div class="col-lg-4">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon name="ni ni-building" gradient="darkred" color="white" shadow
                                    rounded></icon>
                            <h5 class="title text-red mt-2">Vossloh</h5>
                            <p>TS4500 switch machine.<br><br></p>
                        </card>
                    </div>
                    <div class="col-lg-4">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon name="ni ni-building" gradient="darkred" color="white" shadow
                                    rounded>ARS</icon>
                            <h5 class="title text-red mt-2">ARS</h5>
                            <p>switch machine YM-16, HM-17.<br><br></p>
                        </card>
                    </div>
                </div>
            </div>
        </section>
       

    </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
export default {
  name: "Flexdraw",
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>

<style scoped>
ul.list {
    padding-left: 1.2rem!important;
}
.carousel1 {
    height: 200px!important;
}
.draw-badge {
    background-color: #fff!important;
}
</style>